// Sample card from Airbnb
import React from "react";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from 'react';
import swal from 'sweetalert';
import { useParams } from "react-router-dom";
import Form from "react-validation/build/form";
import "react-datepicker/dist/react-datepicker.css";
import APIConfig from "../../../api/APIConfig";
import classes from "./styles.module.css"; 
import ReactLoading from "react-loading";
import {
    Box,
    Center,
    Heading,
    Button,
    Stack,
    Text,
    VStack,
    FormControl,
    FormLabel,
    Input,
    Select,
    Textarea,
} from '@chakra-ui/react';


function EditProposal() {
    const navigate = useNavigate();

    const [namaProposal, setNamaProposal] = useState('');
    const [tanggalMulai, setTanggalMulai] = useState(new Date());
    const [tanggalSelesai, setTanggalSelesai] = useState(new Date());
    const [batasWaktuPembayaran, setBatasWaktuPembayaran] = useState(new Date());
    const [lokasi, setLokasi] = useState('');
    const [deskripsiAktivitas, setDeskripsiAktivitas] = useState('');
    const [namaPosisi, setNamaPosisi] = useState('');
    const [deskripsiPekerjaan, setDeskripsiPekerjaan] = useState('');
    const [kriteriaPeserta, setKriteriaPeserta] = useState('');
    const [kemampuanWajib, setKemampuanWajib] = useState('');
    const [infoTambahan, setInfoTambahan] = useState('');
    const [nominal, setNominal] = useState();
    const [bayar, setBayar] = useState('');
    const [kuota, setKuota] = useState();
    const [statusProposal, setStatusProposal] = useState("Terkumpul")
    const [spinner, setSpinner] = useState(false); 

    const { id } = useParams();

    useEffect(() => {
        getProposalById();
        
    }, []);
    
    const getProposalById = async() => {
        setSpinner(true);
        const response = await APIConfig.get(`/v1/proposal/${id}`);
        const data = await response.data
        setNamaProposal(data.namaProposal);
        setLokasi(data.lokasi);
        setTanggalMulai(data.tanggalMulai);
        setTanggalSelesai(data.tanggalSelesai);
        setDeskripsiAktivitas(data.deskripsiAktivitas);
        setNamaPosisi(data.namaPosisi);
        setDeskripsiPekerjaan(data.deskripsiPekerjaan);
        setKriteriaPeserta(data.kriteriaPeserta);
        setKemampuanWajib(data.kemampuanWajib);
        setInfoTambahan(data.infoTambahan);
        setKuota(data.kuota);
        setNominal(data.nominal);
        setBatasWaktuPembayaran(data.batasWaktuPembayaran);

        setSpinner(false);

        if(data.nominal > 0) setBayar("Iya"); else setBayar("Tidak");
    };


    const updateProposal = async (e) => {
        e.preventDefault();    
        swal("Apakah Anda yakin ingin memperbarui proposal?", {
            buttons: {
                yes: {
                text: "Ya",
                value: "yes"
                },
                no: {
                text: "Kembali",
                value: "no"
                }
        }
        }).then((value) => {
            if (value === "yes") {
                if(bayar === "Iya") {
                    APIConfig.put(`/v1/proposal/${id}`, {
                        namaProposal: namaProposal,
                        tanggalMulai: tanggalMulai,
                        tanggalSelesai: tanggalSelesai,
                        batasWaktuPembayaran : batasWaktuPembayaran,
                        lokasi: lokasi,
                        nominal: nominal,
                        statusProposal: statusProposal,
                        deskripsiAktivitas: deskripsiAktivitas,
                        namaPosisi: namaPosisi,
                        deskripsiPekerjaan: deskripsiPekerjaan,
                        kriteriaPeserta: kriteriaPeserta,
                        kemampuanWajib : kemampuanWajib,
                        infoTambahan: infoTambahan,
                        kuota: kuota,
                    })
                    .then(() => {
                        console.log("berhasil") 
                        navigate("/mitra/profile/proposal");
                        swal({
                            title: "Kamu berhasil memperbarui proposal!",
                            icon: "success",
                            button: "OK",
                          });
            
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                }
                else {
                    APIConfig.put(`/v1/proposal/${id}`, {
                        namaProposal: namaProposal,
                        tanggalMulai: tanggalMulai,
                        tanggalSelesai: tanggalSelesai,
                        batasWaktuPembayaran : null,
                        lokasi: lokasi,
                        nominal: null,
                        statusProposal: statusProposal,
                        deskripsiAktivitas: deskripsiAktivitas,
                        namaPosisi: namaPosisi,
                        deskripsiPekerjaan: deskripsiPekerjaan,
                        kriteriaPeserta: kriteriaPeserta,
                        kemampuanWajib : kemampuanWajib,
                        infoTambahan: infoTambahan,
                        kuota: kuota,
                    })
                    .then(() => {
                        console.log("berhasil") 
                        navigate("/mitra/profile/proposal");
                        swal({
                            title: "Kamu berhasil memperbarui proposal!",
                            icon: "success",
                            button: "OK",
                          });
            
                    })
                    .catch((error) => {
                        console.log(error);
                    })
                }
            }
            return false;
        });
    };

    if (spinner) {
        return (
            <Center py={12}>
                <VStack align='stretch' fontFamily={'Inter'} pb={20}>
                <div className="section">
                    <div className="article">
                        <ReactLoading type="spin" color="#6554C0" />
                    </div>
                </div>
                </VStack>
            </Center>
              
        )
    }

    return (
        <Center py={6}>
        <VStack justifyItems='left' fontFamily={'Inter'}>
            <Text
                pt={10}
                paddingBottom={10}
                color={'gray.700'}
                fontWeight={600}
                fontSize={'2xl'}
                letterSpacing={1.1}
                fontFamily={'Inter'}>
                Edit Proposal
            </Text>
            <Box
                m='10px'
                w='4xl'
                h="100%"
                border='1px'
                borderColor='gray.200'
                justifyContent='left'
                rounded={'2xl'}
                p={6}
                className={classes.box}
                overflow={'hidden'}>
                <VStack 
                spacing={4}
                align='stretch'
                p={3}
                >
                    <Heading
                        mb={6}
                        mt={3}
                        fontSize={'xl'}
                        fontFamily={'Inter'}>
                        Aktivitas
                    </Heading>
                    
                    
                    <Form p={6} onSubmit={updateProposal}>
                        <FormControl pb={6} isRequired fontFamily={'Inter'} >
                        <FormLabel htmlFor='namaProposal'>Nama Proposal</FormLabel>
                        <Input 
                            id='namaProposal' 
                            placeholder='Masukkan nama proposal'
                            value={namaProposal}
                            onChange={(e) => setNamaProposal(e.target.value)}
                            />
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='tanggalMulai'>Tanggal Mulai</FormLabel>
                        <div>
                            <input
                                className={classes.datepicker}
                                name="tanggalMulai"
                                type="date"
                                onChange={(e) => setTanggalMulai(e.target.value)}
                                value={tanggalMulai}
                            />
                        </div>
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='tanggalSelesai'>Tanggal Selesai</FormLabel>
                        <div>
                            <input
                                className={classes.datepicker}
                                name="tanggalSelesai"
                                type="date"
                                onChange={(e) => setTanggalSelesai(e.target.value)}
                                value={tanggalSelesai}
                            />
                        </div>
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'} >
                        <FormLabel htmlFor='lokasi'>Lokasi</FormLabel>
                        <Input 
                            id='lokasi' 
                            placeholder='Masukkan lokasi'
                            value={lokasi}
                            onChange={(e) => setLokasi(e.target.value)}
                            />
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'} >
                        <FormLabel htmlFor='kuota'>Kuota</FormLabel>
                        <Input 
                            id='kuota' 
                            placeholder='Masukkan kuota peserta magang'
                            value={kuota}
                            onChange={(e) => setKuota(e.target.value)}
                            />
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='bayar'>Apakah peserta perlu membayar untuk aktivitas ini?</FormLabel>
                        
                        <Select
                            style={{paddingLeft: "8px", paddingTop: "6px", paddingBottom: "6px", border: '1px solid #F5F5F5', borderRadius: '5px', width: '100%', height:'40px'}} 
                            id='bayar' 
                            onChange={(e) => setBayar(e.target.value)}
                            value={bayar}
                            defaultValue={bayar}
                            >
                                <option value="Iya">Iya</option>
                                <option value="Tidak">Tidak</option>
                        </Select>
                      
                        </FormControl>
                        
                        {bayar === "Iya" ? 
                            <div>
                            <FormControl pb={6} isRequired fontFamily={'Inter'}>
                            <FormLabel htmlFor='nominal'>Nominal</FormLabel>
                            <Input 
                            id='nominal' 
                            placeholder='Masukkan nominal' 
                            value={nominal}
                            onChange={(e) => setNominal(e.target.value)}/>
                            </FormControl>
                            <FormControl pb={6} isRequired fontFamily={'Inter'}>
                            <FormLabel htmlFor='batasWaktuPembayaran'>Batas Waktu Pembayaran</FormLabel>
                            <div>
                                <input
                                    className={classes.datepicker}
                                    name="batasWaktuPembayaran"
                                    type="date"
                                    onChange={(e) => setBatasWaktuPembayaran(e.target.value)}
                                    value={batasWaktuPembayaran}
                                />
                            </div>
                            </FormControl>
                            </div>
                        : 
                            <FormControl pb={6} isRequired fontFamily={'Inter'}>
                            <FormLabel htmlFor='nominal'>Nominal</FormLabel>
                            <Input 
                            isDisabled
                            id='nominal' 
                            placeholder='Magang tidak berbayar' 
                            value={null}
                            onChange={(e) => setNominal(null)}/>
                            </FormControl>  
                        }

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='deskripsiAktivitas'>Deskripsi Aktivitas</FormLabel>
                        <Textarea 
                        type='text'
                        id='deskripsiAktivitas' 
                        placeholder='Masukkan deskripsi aktivitas' 
                        value={deskripsiAktivitas}
                        onChange={(e) => setDeskripsiAktivitas(e.target.value)}/>
                        </FormControl>

                        <Heading
                        mb={6}
                        mt={3}
                        fontSize={'xl'}
                        fontFamily={'Inter'}>
                        Posisi yang dibutuhkan
                        </Heading>

                        <FormControl pb={6}  isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='namaPosisi'>Nama posisi</FormLabel>
                        <Input 
                        id='namaPosisi' 
                        placeholder='Masukkan nama posisi' 
                        value={namaPosisi}
                        onChange={(e) => setNamaPosisi(e.target.value)}/>
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='deskripsiPekerjaan'>Deskripsi Pekerjaan</FormLabel>
                        <Textarea 
                        type='text'
                        id='deskripsiPekerjaan' 
                        placeholder='Requirements, Kualifikasi peserta, Skills wajib' 
                        value={deskripsiPekerjaan}
                        onChange={(e) => setDeskripsiPekerjaan(e.target.value)}/>
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='kriteriaPeserta'>Kriteria Peserta</FormLabel>
                        <Textarea 
                        type='text'
                        id='kriteriaPeserta' 
                        placeholder='Masukkan kriteria peserta yang diinginkan' 
                        value={kriteriaPeserta}
                        onChange={(e) => setKriteriaPeserta(e.target.value)}/>
                        </FormControl>

                        <FormControl pb={6} isRequired fontFamily={'Inter'}>
                        <FormLabel htmlFor='kemampuanWajib'>Kemampuan Wajib</FormLabel>
                        <Textarea 
                        type='text'
                        id='kemampuanWajib' 
                        placeholder='Masukkan kemampuan wajib yang dibutuhkan' 
                        value={kemampuanWajib}
                        onChange={(e) => setKemampuanWajib(e.target.value)}/>
                        </FormControl>

                        <FormControl pb={6} fontFamily={'Inter'}>
                        <FormLabel htmlFor='infoTambahan'>Info Tambahan</FormLabel>
                        <Textarea 
                        type='text'
                        id='infoTambahan' 
                        placeholder='Info Tambahan' 
                        value={infoTambahan}
                        onChange={(e) => setInfoTambahan(e.target.value)}/>
                        </FormControl>



                        <Stack pt={6} justifyContent='right' direction='row' spacing={4} align='center'>
                            <Button 
                                onClick={() => navigate(-1)}
                                p={6} rounded={'xl'} colorScheme='purple' variant='outline'>
                                Kembali
                            </Button>
                            <Button 
                                type='submit'
                                p={6}
                                colorScheme='purple' 
                                rounded={'xl'}
                                variant='solid'>
                                Simpan
                            </Button>
                        </Stack>
                    </Form>
                </VStack>
            </Box>
        </VStack>
        </Center>
    );
}

export default EditProposal;